import { FC, useEffect } from 'react';

const SCRIPT_SRC = 'https://tricao-chat.web.app/widget.iife.js';
const API_URL = 'https://tricao-chatbot-production.up.railway.app';

const ChatWidget: FC = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.defer = true;
    script.setAttribute('data-api-url', API_URL);
    document.body.appendChild(script);
  }, []);

  return null;
};

export default ChatWidget;
